module.exports = __webpack_public_path__ + "static/media/plan_light.2c9fa0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/plan_light.png
// module id = 3545
// module chunks = 3